import LegalLayout from "@/components/site/LegalLayout";

const SECTIONS = [
  {
    title: "1 · Our Commitment",
    body: "BoT Summit is dedicated to providing a respectful, harassment-free and productive experience for every delegate, speaker, sponsor, partner, volunteer and staff member — regardless of gender, gender identity and expression, sexual orientation, disability, neurotype, physical appearance, body size, ethnicity, nationality, age, religion or technology choices. By attending, you agree to uphold this Code of Conduct in all summit-related spaces, online and offline.",
  },
  {
    title: "2 · Expected Behaviour",
    items: [
      "Be respectful, professional and considerate in all interactions.",
      "Attribute credit to collaborators and prior work when presenting.",
      "Use language and imagery suitable for a diverse, professional audience.",
      "Listen actively and give others space to contribute.",
      "Honour the confidentiality of closed-door sessions and Chatham House rules where stated.",
    ],
  },
  {
    title: "3 · Unacceptable Behaviour",
    body: "The following will not be tolerated at any BoT Summit venue, event, lodging, transport, social gathering or digital platform:",
    items: [
      "Harassment, intimidation, stalking, unwelcome photography or recording.",
      "Discriminatory or offensive verbal, written or physical conduct.",
      "Disruption of talks, workshops, panels or networking activities.",
      "Use of sexualised imagery, language or attire in summit spaces.",
      "Advocating for or encouraging any of the above.",
    ],
  },
  {
    title: "4 · Sponsors, Exhibitors & Partners",
    body: "Sponsors, exhibitors and partners are held to the same standards as delegates. Booths and staff must avoid sexualised imagery, clothing or interactions and must respect all attendees. Recruiting activity is welcome, but must be consensual and not disruptive.",
  },
  {
    title: "5 · Reporting an Incident",
    body: "If you experience or witness conduct that violates this Code — or have any other concern — please contact the BoT Summit Trust & Safety team immediately:",
    items: [
      "On-site: find any staff member in a branded lanyard or visit the Help Desk.",
      "Email: info@botsummits.com (subject: Code of Conduct).",
      "Phone / WhatsApp: +44 7915361665 · +91 8825035701 (24x7 during the event dates).",
    ],
    after: "Reports are handled confidentially. Only the minimum team necessary to resolve the matter will be informed.",
  },
  {
    title: "6 · Consequences",
    body: "Participants asked to stop any unacceptable behaviour are expected to comply immediately. The organisers may take any action deemed appropriate — including warnings, removal without refund, banning from future editions, and, where warranted, reporting to law-enforcement authorities.",
  },
  {
    title: "7 · Scope",
    body: "This Code applies to all official BoT Summit venues, satellite events, hosted lodgings, transport arranged by the summit, social programmes, sponsor activations and any online channel bearing the BoT Summit name — including WhatsApp, LinkedIn, Slack and the delegate app.",
  },
  {
    title: "8 · Acknowledgement",
    body: "By registering for BoT Summit 2026, you confirm that you have read, understood and will abide by this Code of Conduct. We thank you for helping us build a safer, more inclusive and more generative summit for the technology community.",
  },
];

export default function CodeOfConduct() {
  return (
    <LegalLayout
      eyebrow="/ Policy · Code of Conduct"
      title="Code of Conduct"
      updated="December 2025"
    >
      <p className="lead text-lg text-zinc-700 leading-relaxed">
        BoT Summit convenes the builders, operators and policymakers shaping modern
        technology. We believe the best outcomes come from a floor where every
        participant feels safe, heard and respected. This Code of Conduct sets out
        the standards everyone at the summit is expected to uphold.
      </p>

      <div className="mt-12 space-y-10">
        {SECTIONS.map((s, i) => (
          <section key={i} data-testid={`coc-section-${i}`}>
            <h2 className="font-display text-xl md:text-2xl uppercase tracking-tight border-t border-zinc-200 pt-6">
              {s.title}
            </h2>
            {s.body && <p className="mt-4 text-zinc-700 leading-relaxed">{s.body}</p>}
            {s.items && (
              <ul className="mt-4 space-y-2">
                {s.items.map((it, k) => (
                  <li key={k} className="flex gap-3 text-zinc-700">
                    <span className="text-[#002FA7] font-mono text-sm mt-1 shrink-0">
                      0{k + 1}
                    </span>
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            )}
            {s.after && <p className="mt-4 text-zinc-700 leading-relaxed">{s.after}</p>}
          </section>
        ))}
      </div>

      <div className="mt-16 p-6 border border-zinc-200 bg-zinc-50">
        <div className="overline text-zinc-500 mb-2">Need to reach us</div>
        <div className="font-mono text-sm">
          Email: info@botsummits.com · Phone: +44 7915361665 · +91 8825035701
        </div>
      </div>
    </LegalLayout>
  );
}
